module.exports = __webpack_public_path__ + "officialStatic/img/new27.c535910.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/new27.jpg
// module id = +xeW
// module chunks = 0